import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {
  heading_content: 'heading_content',
  heading: 'heading',
  body_text: 'body_text',
  promo_pill: 'promo_pill',
  media: 'media',
  media_image: 'media_image',
  media_video: 'media_video',
  has_section_rating: 'has_section_rating',
  cta: 'cta',
  subheading_content: 'subheading_content',
  testimonial: 'testimonial',
  rating_badge: 'rating_badge',
};

export default {
  crawlType: 'carousel',
  [IDENTIFIER_TAGS.media_video]: [
    {
      type: sectionType.sectionCardMediaSlider03,
      tags: [IDENTIFIER_TAGS.subheading_content, IDENTIFIER_TAGS.media, IDENTIFIER_TAGS.heading_content],
      priority: 1,
    },
  ],
  [IDENTIFIER_TAGS.testimonial]: [
    {
      type: sectionType.sectionReviewGrid02,
      tags: [
        IDENTIFIER_TAGS.subheading_content,
        IDENTIFIER_TAGS.has_section_rating,
        IDENTIFIER_TAGS.testimonial,
        IDENTIFIER_TAGS.heading_content,
      ],
      priority: 2,
    },
  ],
  matchTemplates: [
    {
      type: sectionType.sectionCardSliderYuri,
      tags: [IDENTIFIER_TAGS.subheading_content, IDENTIFIER_TAGS.media, IDENTIFIER_TAGS.heading_content],
      priority: 3,
    },
    {
      type: sectionType.sectionMarqueeShopzovya,
      tags: [
        IDENTIFIER_TAGS.subheading_content,
        IDENTIFIER_TAGS.media,
        IDENTIFIER_TAGS.heading_content,
        IDENTIFIER_TAGS.rating_badge,
      ],
      priority: 4,
    },
  ],
};
